// Fasst statische Objekte zu je einem Mesh pro Material zusammen (weniger Draw Calls).
import * as THREE from "three"
import { mergeGeometries } from "three/addons/utils/BufferGeometryUtils.js"

export function mergeStatic(objects, parent) {
  const byMaterial = new Map()
  parent.updateMatrixWorld(true)
  const parentInverse = new THREE.Matrix4().copy(parent.matrixWorld).invert()
  for (const object of objects) {
    object.updateMatrixWorld(true)
    object.traverse((child) => {
      if (!child.isMesh) return
      let geometry = child.geometry.index ? child.geometry.toNonIndexed() : child.geometry.clone()
      for (const name of Object.keys(geometry.attributes)) if (!["position", "normal"].includes(name)) geometry.deleteAttribute(name)
      geometry.applyMatrix4(new THREE.Matrix4().multiplyMatrices(parentInverse, child.matrixWorld))
      if (!byMaterial.has(child.material)) byMaterial.set(child.material, { geometries: [], castShadow: child.castShadow })
      byMaterial.get(child.material).geometries.push(geometry)
    })
    object.removeFromParent()
  }
  for (const [material, { geometries, castShadow }] of byMaterial) {
    const mesh = new THREE.Mesh(mergeGeometries(geometries), material)
    mesh.castShadow = castShadow
    mesh.receiveShadow = true
    parent.add(mesh)
    geometries.forEach((g) => g.dispose())
  }
}
